module.exports = __webpack_public_path__ + "static/media/YM01_5.fbd2c97f.jpg";